import React, {Component} from 'react';
import {Toast,NavBar,Modal} from 'antd-mobile';
import './index.less';
import {getBill} from '../../../../service/waterBillService';
import moment from "moment";
import {connect} from "react-redux";
let date = moment(new Date()).add('year',0).format("YYYY年MM月");
let dateValue =  moment(new Date()).add('year',0).format("YYYY年MM月");
let firstDate = moment(new Date()).add('year',0).format("YYYYMM");
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class WaterBill extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal:false,
            beforeMonth:[],
            billDate:'当前账期：',
            firstInterCityOrderBill:{},
            firstshuntOrderConbinationBill:{},
            firstCityOrderBill:{},
            firstTailoredBusOrderBill:{},
            firstShuttleorderBill:{},
            firstBringorderBill:{},
            secondInterCityOrderBill:{},
            secondshuntOrderConbinationBill:{},
            secondCityOrderBill:{},
            secondTailoredBusOrderBill:{},
            secondShuttleorderBill:{},
            secondBringorderBill:{},
            propsFirstData:{},//第一期
            propsSecondData:{},//第二期
        };
    }

    componentDidMount() {
       this.getWaterBill(firstDate);
       this.getMonth();
    }
    //手动生成前6个月的数据
    getMonth = () =>{
        var dataArr = [];
        var data = new Date();
        var year = data.getFullYear();
        data.setMonth(data.getMonth(), 1)//获取到当前月份,设置月份
        for (var i = 0; i < 6; i++) {
            data.setMonth(data.getMonth() - 1);//每次循环一次 月份值减1
            var m = data.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            dataArr.push({
                "month":data.getFullYear() + "年" + (m) + '月',
                "id":data.getFullYear()+(m)
            })
            
        }
        this.setState({
            beforeMonth:dataArr
        })
    }
    getWaterBill = (month) =>{
        let params = {
            token: this.props.userInfo.token,
            "data":
            {
                "billQuantum":month,
                "userType":1
            }
        };
        Toast.loading("正在加载",0);
        getBill(params).then((res) => {
            Toast.hide();
            console.log(res)
            if (res.data.code === '0000') {
                if(res.data.data.length === 0 ){
                    this.setState({
                        firstInterCityOrderBill:{},
                        firstshuntOrderConbinationBill:{},
                        secondInterCityOrderBill:{},
                        secondshuntOrderConbinationBill:{},
                        firstTailoredBusOrderBill:{},
                        secondTailoredBusOrderBill:{},
                        firstShuttleorderBill:{},
                        firstBringorderBill:{},
                        secondBringorderBill:{},
                        secondShuttleorderBill:{},
                    })
                    Toast.info("您选择的月份暂无数据");
                }else{
                    this.setState({
                        propsFirstData:res.data.data[0],
                        propsSecondData:res.data.data[1],
                        firstInterCityOrderBill:res.data.data[0].interCityOrderBill,//第一期城际账单
                        firstshuntOrderConbinationBill:res.data.data[0].shuntOrderConbinationBill,//第一期分流账单
                        firstCityOrderBill:res.data.data[0].cityOrderBill,//第一期城内账单
                        firstTailoredBusOrderBill:res.data.data[0].tailoredBusOrderBill,//第一期包车账单
                        firstShuttleorderBill:res.data.data[0].shuttleOrderBill,//第一期接驳订单
                        firstBringorderBill:res.data.data[0].logisticsBill,//第一期带货账单
                        secondInterCityOrderBill:res.data.data[1].interCityOrderBill,//第二期城际账单
                        secondshuntOrderConbinationBill:res.data.data[1].shuntOrderConbinationBill,//第二期分流账单
                        secondCityOrderBill:res.data.data[1].cityOrderBill,//第二期城内账单
                        secondTailoredBusOrderBill:res.data.data[1].tailoredBusOrderBill,//第二期包车账单
                        secondShuttleorderBill:res.data.data[1].shuttleOrderBill,//第二期接驳订单
                        secondBringorderBill:res.data.data[1].logisticsBill,//第二期带货账单
                    })
                }
                
            } else if (res.data.code === '1401') {
                document.location = `js://toLogin?token=${this.props.userInfo.token}`;
            } else {
                Toast.info(res.data.msg);
            }
        })
    }
   changeDate =(month,value) =>{
    this.setState({
        modal:false,
        billDate:'您选择的账期：'
    })
    this.getWaterBill(month)
    date = value
   }
    render() {
        let {firstInterCityOrderBill,firstshuntOrderConbinationBill,firstCityOrderBill,firstTailoredBusOrderBill,firstShuttleorderBill,firstBringorderBill,secondInterCityOrderBill,secondshuntOrderConbinationBill,secondCityOrderBill,secondTailoredBusOrderBill,secondShuttleorderBill,propsFirstData,propsSecondData,secondBringorderBill} = this.state
        return (
            <div className="waterBill">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() =>this.props.history.goBack()}></i>}
                >流水账单</NavBar>
                <div className="changeDate" onClick={() => this.setState({modal:!this.state.modal})}>
                    <div>
                        <div>{this.state.billDate} &nbsp;<p>{date}</p></div><div><span>查看历史账期</span><i className="icon iconfont icontiaozhuan"></i></div>
                    </div>
                </div>
                <div className="content">
                    <div className="period">
                        <div className="firstPeriod">第一期</div>
                        <div className="mainBill"><span>主线账单 <span className="span">{firstInterCityOrderBill.isSettlement == 1 ? '已结算':'未结算'}</span></span> <div onClick={()=>this.props.history.push('/DealList',{startDate:propsFirstData.billTimeStart,endDate:propsFirstData.billTimeEnd,userType:firstInterCityOrderBill.userType,propDate:date})}>交易明细</div></div>
                        <div className="amount">
                            <div><span>{firstInterCityOrderBill.totalPrice ? Math.abs(firstInterCityOrderBill.totalPrice):0}</span><p>总收入金额（元）</p></div>
                            <div><span>{firstInterCityOrderBill.disbursePrice ? Math.abs(firstInterCityOrderBill.disbursePrice):0}</span><p>应支出金额（元）</p></div>
                        </div>
                        <div className="service">
                            <div><span className="firstSpan">服务行程</span><span>{firstInterCityOrderBill.serviceCount ? firstInterCityOrderBill.serviceCount : 0}</span></div>
                            <div><span className="secondSpan">服务乘客</span><span>{firstInterCityOrderBill.servicePeopleCount ? firstInterCityOrderBill.servicePeopleCount : 0}</span></div>
                        </div>
                        <div className="mainBill"><span>分流账单 <span className="span">{firstshuntOrderConbinationBill.isSettlement == 1 ? '已结算':'未结算'}</span></span> <div onClick={()=>this.props.history.push('/DealList',{startDate:propsFirstData.billTimeStart,endDate:propsFirstData.billTimeEnd,userType:firstshuntOrderConbinationBill.userType,propDate:date})}>交易明细</div></div>
                        <div className="amount">
                            <div><span>{firstshuntOrderConbinationBill.totalPrice ? Math.abs(firstshuntOrderConbinationBill.totalPrice):0}</span><p>总收入金额（元）</p></div>
                            <div><span>{firstshuntOrderConbinationBill.disbursePrice ? Math.abs(firstshuntOrderConbinationBill.disbursePrice):0}</span><p>应支出金额（元）</p></div>
                        </div>
                        <div className="service">
                            <div><span className="firstSpan">已完成订单量</span><span>{firstshuntOrderConbinationBill.serviceCount ? firstshuntOrderConbinationBill.serviceCount:0}</span></div>
                        </div>
                        <div className="mainBill"><span>专车预约收入 <span className="span">{firstTailoredBusOrderBill.isSettlement == 1 ? '已结算':'未结算'}</span></span> <div onClick={()=>this.props.history.push('/DealList',{startDate:propsFirstData.billTimeStart,endDate:propsFirstData.billTimeEnd,userType:firstTailoredBusOrderBill.userType,propDate:date})}>交易明细</div></div>
                        <div className="amount">
                            <div><span>{firstTailoredBusOrderBill.totalPrice ? Math.abs(firstTailoredBusOrderBill.totalPrice):0}</span><p>总收入金额（元）</p></div>
                            <div><span>{firstTailoredBusOrderBill.disbursePrice ? Math.abs(firstTailoredBusOrderBill.disbursePrice):0}</span><p>应支出金额（元）</p></div>
                        </div>
                        <div className="service">
                            <div><span className="firstSpan">已完成订单量</span><span>{firstTailoredBusOrderBill.serviceCount ? firstTailoredBusOrderBill.serviceCount:0}</span></div>
                        </div>
                        <div className="mainBill"><span>城内收入 <span className="span">{firstCityOrderBill.isSettlement == 1 ? '已结算':'未结算'}</span></span> <div onClick={()=>this.props.history.push('/DealList',{startDate:propsFirstData.billTimeStart,endDate:propsFirstData.billTimeEnd,userType:firstCityOrderBill.userType,propDate:date})}>交易明细</div></div>
                        <div className="amount">
                            <div><span>{firstCityOrderBill.totalPrice ? Math.abs(firstCityOrderBill.totalPrice):0}</span><p>总收入金额（元）</p></div>
                            <div><span>{firstCityOrderBill.disbursePrice ? Math.abs(firstCityOrderBill.disbursePrice):0}</span><p>应支出金额（元）</p></div>
                        </div>
                        <div className="service">
                            <div><span className="firstSpan">已完成订单量</span><span>{firstCityOrderBill.serviceCount ? firstCityOrderBill.serviceCount:0}</span></div>
                        </div>
                        <div className="mainBill"><span>接驳收入 <span className="span">{firstShuttleorderBill.isSettlement == 1 ? '已结算':'未结算'}</span></span> <div onClick={()=>this.props.history.push('/DealList',{startDate:propsFirstData.billTimeStart,endDate:propsFirstData.billTimeEnd,userType:firstShuttleorderBill.userType,propDate:date})}>交易明细</div></div>
                        <div className="amount">
                            <div><span>{firstShuttleorderBill.totalPrice ? Math.abs(firstShuttleorderBill.totalPrice):0}</span><p>总收入金额（元）</p></div>
                            <div><span>{firstShuttleorderBill.disbursePrice ? Math.abs(firstShuttleorderBill.disbursePrice):0}</span><p>应支出金额（元）</p></div>
                        </div>
                        <div className="service">
                            <div><span className="firstSpan">已完成订单量</span><span>{firstShuttleorderBill.serviceCount ? firstShuttleorderBill.serviceCount:0}</span></div>
                        </div>
                        <div className="mainBill"><span>带货收入 <span className="span">{firstBringorderBill.isSettlement == 1 ? '已结算':'未结算'}</span></span> <div onClick={()=>this.props.history.push('/DealList',{startDate:propsFirstData.billTimeStart,endDate:propsFirstData.billTimeEnd,userType:firstBringorderBill.userType,propDate:date})}>交易明细</div></div>
                        <div className="amount">
                            <div><span>{firstBringorderBill.totalPrice ? Math.abs(firstBringorderBill.totalPrice):0}</span><p>总收入金额（元）</p></div>
                            <div><span>{firstBringorderBill.disbursePrice ? Math.abs(firstBringorderBill.disbursePrice):0}</span><p>应支出金额（元）</p></div>
                        </div>
                        <div className="service">
                            <div><span className="firstSpan">已完成订单量</span><span>{firstBringorderBill.serviceCount ? firstBringorderBill.serviceCount:0}</span></div>
                        </div>
                    </div>
                    <div className="period">
                        <div className="firstPeriod">第二期</div>
                        <div className="mainBill"><span>主线账单 <span className="span">{secondInterCityOrderBill.isSettlement == 1 ? '已结算':'未结算'}</span></span> <div onClick={()=>this.props.history.push('/DealList',{startDate:propsSecondData.billTimeStart,endDate:propsSecondData.billTimeEnd,userType:secondInterCityOrderBill.userType,propDate:date})}>交易明细</div></div>
                        <div className="amount">
                            <div><span>{secondInterCityOrderBill.totalPrice ? Math.abs(secondInterCityOrderBill.totalPrice):0}</span><p>总收入金额（元）</p></div>
                            <div><span>{secondInterCityOrderBill.disbursePrice ? Math.abs(secondInterCityOrderBill.disbursePrice):0}</span><p>应支出金额（元）</p></div>
                        </div>
                        <div className="service">
                            <div><span className="firstSpan">服务行程</span><span>{secondInterCityOrderBill.serviceCount ? secondInterCityOrderBill.serviceCount : 0}</span></div>
                            <div><span className="secondSpan">服务乘客</span><span>{secondInterCityOrderBill.servicePeopleCount ? secondInterCityOrderBill.servicePeopleCount : 0}</span></div>
                        </div>
                        <div className="mainBill"><span>分流账单 <span className="span">{secondshuntOrderConbinationBill.isSettlement == 1 ? '已结算':'未结算'}</span></span> <div onClick={()=>this.props.history.push('/DealList',{startDate:propsSecondData.billTimeStart,endDate:propsSecondData.billTimeEnd,userType:secondshuntOrderConbinationBill.userType,propDate:date})}>交易明细</div></div>
                        <div className="amount">
                            <div><span>{secondshuntOrderConbinationBill.totalPrice ? Math.abs(secondshuntOrderConbinationBill.totalPrice):0}</span><p>总收入金额（元）</p></div>
                            <div><span>{secondshuntOrderConbinationBill.disbursePrice ? Math.abs(secondshuntOrderConbinationBill.disbursePrice):0}</span><p>应支出金额（元）</p></div>
                        </div>
                        <div className="service">
                            <div><span className="firstSpan">已完成订单量</span><span>{secondshuntOrderConbinationBill.serviceCount ?secondshuntOrderConbinationBill.serviceCount:0 }</span></div>
                        </div>
                        <div className="mainBill"><span>专车预约收入 <span className="span">{secondTailoredBusOrderBill.isSettlement == 1 ? '已结算':'未结算'}</span></span> <div onClick={()=>this.props.history.push('/DealList',{startDate:propsSecondData.billTimeStart,endDate:propsSecondData.billTimeEnd,userType:secondTailoredBusOrderBill.userType,propDate:date})}>交易明细</div></div>
                        <div className="amount">
                            <div><span>{secondTailoredBusOrderBill.totalPrice ? Math.abs(secondTailoredBusOrderBill.totalPrice):0}</span><p>总收入金额（元）</p></div>
                            <div><span>{secondTailoredBusOrderBill.disbursePrice ? Math.abs(secondTailoredBusOrderBill.disbursePrice):0}</span><p>应支出金额（元）</p></div>
                        </div>
                        <div className="service">
                            <div><span className="firstSpan">已完成订单量</span><span>{secondTailoredBusOrderBill.serviceCount ? secondTailoredBusOrderBill.serviceCount:0}</span></div>
                        </div>
                        <div className="mainBill"><span>城内收入 <span className="span">{secondCityOrderBill.isSettlement == 1 ? '已结算':'未结算'}</span></span> <div onClick={()=>this.props.history.push('/DealList',{startDate:propsSecondData.billTimeStart,endDate:propsSecondData.billTimeEnd,userType:secondCityOrderBill.userType,propDate:date})}>交易明细</div></div>
                        <div className="amount">
                            <div><span>{secondCityOrderBill.totalPrice ? Math.abs(secondCityOrderBill.totalPrice):0}</span><p>总收入金额（元）</p></div>
                            <div><span>{secondCityOrderBill.disbursePrice ? Math.abs(secondCityOrderBill.disbursePrice):0}</span><p>应支出金额（元）</p></div>
                        </div>
                        <div className="service">
                            <div><span className="firstSpan">已完成订单量</span><span>{secondCityOrderBill.serviceCount ? secondCityOrderBill.serviceCount:0}</span></div>
                        </div>
                        <div className="mainBill"><span>接驳收入 <span className="span">{secondShuttleorderBill.isSettlement == 1 ? '已结算':'未结算'}</span></span> <div onClick={()=>this.props.history.push('/DealList',{startDate:propsSecondData.billTimeStart,endDate:propsSecondData.billTimeEnd,userType:secondShuttleorderBill.userType,propDate:date})}>交易明细</div></div>
                        <div className="amount">
                            <div><span>{secondShuttleorderBill.totalPrice ? Math.abs(secondShuttleorderBill.totalPrice):0}</span><p>总收入金额（元）</p></div>
                            <div><span>{secondShuttleorderBill.disbursePrice ? Math.abs(secondShuttleorderBill.disbursePrice):0}</span><p>应支出金额（元）</p></div>
                        </div>
                        <div className="service">
                            <div><span className="firstSpan">已完成订单量</span><span>{secondShuttleorderBill.serviceCount ? secondShuttleorderBill.serviceCount:0}</span></div>
                        </div>
                        <div className="mainBill"><span>带货收入 <span className="span">{secondBringorderBill.isSettlement == 1 ? '已结算':'未结算'}</span></span> <div onClick={()=>this.props.history.push('/DealList',{startDate:propsSecondData.billTimeStart,endDate:propsSecondData.billTimeEnd,userType:secondBringorderBill.userType,propDate:date})}>交易明细</div></div>
                        <div className="amount">
                            <div><span>{secondBringorderBill.totalPrice ? Math.abs(secondBringorderBill.totalPrice):0}</span><p>总收入金额（元）</p></div>
                            <div><span>{secondBringorderBill.disbursePrice ? Math.abs(secondBringorderBill.disbursePrice):0}</span><p>应支出金额（元）</p></div>
                        </div>
                        <div className="service">
                            <div><span className="firstSpan">已完成订单量</span><span>{secondBringorderBill.serviceCount ? secondBringorderBill.serviceCount:0}</span></div>
                        </div>
                    </div>
                    <div className="footer">*调度人员累计收入金额为各司机收入金额总和，自身无收入项</div>
                </div>
                <Modal
                    popup
                    visible={this.state.modal}
                    animationType="slide-up"
                    className="chooseMonthModal"
                >
                <div className="chooseMonthContent">
                    <div className="chooseMonth"><span>选择月份</span><i className="icon iconfont iconguanbidanchuang" onClick={()=>this.setState({modal:false})}/></div>
                    <div className="current" onClick={()=>this.changeDate(firstDate,dateValue)}>当前月份</div>
                    <div className="beforeMonth">
                        {
                            this.state.beforeMonth.map((item,i) => (
                                <div key={i} className="beforeMonthDiv" onClick={()=>this.changeDate(item.id,item.month)}>{item.month}</div>
                            ))
                        }
                    </div>
                </div>
                </Modal>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Home/Index/WaterBill/index.js